<div class="page-container">
  @if (client$ | async; as clientResult) {
    <app-toolbar [title]="('COMMON.ADMIN' | translate) + (clientResult.data ? ' — ' + clientResult.data.name : '')"></app-toolbar>

    <div class="page">
      <div class="client-dashboard">
        @if (clientResult.isSuccess) {
          @if (organizations$ | async; as organizations) {
            @if (selectedOrganizationIds$ | async; as selectedOrganizationIds) {
              @if (organizations.length > 1) {
                <div class="filters">
                  <app-multi-filter
                    [name]="'organizationFilter'"
                    [idKey]="'id'"
                    [labelTranslationKey]="'COMMON.ORGANIZATIONS'"
                    [icon]="'apartment'"
                    [fontSet]="null"
                    [values]="selectedOrganizationIds"
                    [options]="organizations"
                    [displayWith]="displayOrganization"
                    [displaySelected]="displaySelectedOrganizations(organizations)"
                    (valueChange)="onOrganizationChange($event)"
                    (clear)="onOrganizationClear()"
                  ></app-multi-filter>
                </div>
              }

              @if (currentUser$ | async; as user) {
                <app-analytics-dashboard
                  [organizationIds$]="organizationIds$"
                  [dashboardUrl]="user.organization.client.dashboardUrl"
                  [showAudioMetrics]="true"
                ></app-analytics-dashboard>
              }
            }
          }
        } @else if (clientResult.isLoading) {
          <app-spinner></app-spinner>
        } @else if (clientResult.isError) {
          <h2 class="failed-to-load">{{ 'COMMON.FAILED_TO_LOAD' | translate }}</h2>
        }
      </div>
    </div>
  }
</div>
